// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_3iseE){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_R3YFV .dualColumn_OodHO{display:flex;align-content:space-between}.nsAddressForm_R3YFV .dualColumn_OodHO .firstCol_1M8i2{margin-right:20px}.optional_2HGAw{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_3iseE",
	"nsAddressForm": "nsAddressForm_R3YFV",
	"dualColumn": "dualColumn_OodHO",
	"firstCol": "firstCol_1M8i2",
	"optional": "optional_2HGAw"
};
module.exports = exports;
